<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/blog.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-2">
                  <div class="pagename">
                    <h3 class="card-title">Total Mentors</h3>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ totalMentorsCount ? totalMentorsCount : 0 }}</h2>
                  </div>
                </div>

                <div class="col-md-9 text-end">
                  <div class="row justify-content-end align-items-end">
                    <div class="col-auto px-1">
                      <div class="total-count form-group mb-0">
                        <label for="" class="font-weight-normal m-0"
                          >Status</label
                        >
                        <select
                          class="form-control ms_drpdown"
                          id="approve_status"
                          [(ngModel)]="filterData.status"
                          (change)="setFilterData($event)"
                        >
                          <option value="mentor">ALL</option>
                          <option value="pending_mentor">PENDING</option>
                          <option selected value="approved_mentor">
                            APPROVED
                          </option>
                          <option selected value="rejected_mentor">
                            REJECTED
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-auto">
                      <div
                        class="row justify-content-around align-items-end position-relative searchx"
                      >
                        <div class="col-auto px-1">
                          <div class="form-group m-0 position-relative">
                            <label for="" class="font-weight-normal m-0"
                              >From Date
                            </label>
                            <input
                              type="date"
                              class="form-control mr-3"
                              [max]="today"
                              required
                              name="startDate"
                              (keydown)="blockTyping($event)"
                              placeholder="From Date"
                              [(ngModel)]="startDate"
                            />
                            <small
                              *ngIf="isSubmitted && !startDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >From Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <div class="form-group m-0 position-relative">
                            <label for="" class="font-weight-normal m-0"
                              >To Date</label
                            >
                            <input
                              type="date"
                              class="form-control mr-3"
                              (keydown)="blockTyping($event)"
                              [max]="today"
                              required
                              name="endDate"
                              placeholder="To Date"
                              [(ngModel)]="endDate"
                            />
                            <small
                              *ngIf="isSubmitted && !endDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >To Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onSearch()"
                          >
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </button>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onReset()"
                          >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                          </button>
                        </div>

                        <small
                          *ngIf="
                            isSubmitted && dateInvalid && startDate && endDate
                          "
                          class="text-danger d-block text-center"
                          style="
                            position: absolute;
                            bottom: -20px;
                            margin-left: -50px;
                          "
                        >
                          Please ensure the From Date is earlier than or equal
                          to the To Date
                        </small>
                      </div>
                    </div>

                    <div class="col-auto px-1">
                      <div class="excel text-end">
                        <button
                          type="button"
                          [disabled]="!exl"
                          class="btn btn-primary addbtn"
                          (click)="exportToExcel()"
                        >
                          <i class="fa fa-file-excel-o"></i>&nbsp; Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                id="allmentors"
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#Sl</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      Approve/Reject By
                    </th>
                    <th
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      Approve/Reject Date
                    </th>
                    <th
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      Inactivated By
                    </th>
                    <th
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      Inactivated Date
                    </th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody *ngIf="allMentorsList?.length != 0">
                  <tr
                    *ngFor="let item of allMentorsList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.status }}</td>
                    <td
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                      [ngStyle]="
                        item.approved_rejected_by_name
                          ? {}
                          : { 'padding-left': '10px' }
                      "
                    >
                      {{
                        item.approved_rejected_by_name &&
                        item.status != "PENDING"
                          ? item.approved_rejected_by_name
                          : "-"
                      }}
                    </td>
                    <td
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      {{
                        item.approved_rejected_date &&
                        item.approve_status != "PENDING"
                          ? item.approved_rejected_date
                          : "-"
                      }}
                    </td>
                    <td
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      {{
                        item.inactivated_by_name &&
                        item.approve_status != "PENDING"
                          ? item.inactivated_by_name
                          : "-"
                      }}
                    </td>
                    <td
                      [ngClass]="{
                        'd-none': filterData.status == 'pending_mentor'
                      }"
                    >
                      {{
                        item.inactivated_date &&
                        item.approve_status != "PENDING"
                          ? item.inactivated_date
                          : "-"
                      }}
                    </td>

                    <td>{{ item.created_at }}</td>
                  </tr>
                </tbody>

                <tbody *ngIf="allMentorsList?.length == 0">
                  <tr>
                    <td colspan="8" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
